import React, { useState, useEffect, useRef } from "react";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { formattedDateLong } from "../Date";
import {
  AddCircular,
  ApproveCircular,
  DeleteCircular,
  RejectCircular,
  UpdateCicular
} from "./ProjectDetailsCrudButtons";

import { handleErrorToast } from "../CustomFunctions";

import { toTitleCase } from '../FormdataComponent';
import usePermission from "../../config/permissions";
import { DocumentfOLDIcon, DocumentIcon } from "../AllSvg"
import { AlertCircle, Briefcase, Building2, Calendar, ChevronDown, ChevronRight, ChevronUp, FileText, Filter, Folder, Hash, IndianRupee, Loader, Package, Paperclip, Save, Search, Sparkles, Tag, Trash2, User, X } from 'lucide-react';


const SiteManagement = () => {

  const [buffer, setBuffering] = useState(true); //buffering logic

  const [toggleCompany, setToggleCompany] = useState("null");
  const [sectorData, setSectorData] = useState([]);
  const [selectedSearch, setSearch] = useState("");
  const [expandedRow, setExpandedRow] = useState(null);
  const [showFilters, setShowFilters] = useState(true);

  const { PERMISSION_AUTHORITY } = usePermission();

  const role = sessionStorage.getItem('sitemanagement_role');

  const getSiteCirculars = async () => {
    setBuffering(true); // Start Buffering
    let url;
    try {
      url = role === "Admin"
        ? `${BASE_URL}/siteproject/circularuploadbyadminaprroval/${toggleCompany}/`
        : `${BASE_URL}/siteproject/circularupload/`;

      const sub = await axios.get(url);
      setSectorData(sub.data);
    } catch (err) {
      handleErrorToast(err); // Toast Logic
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getSiteCirculars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleCompany]);

  const applyFilters = () => {
    let filtered = sectorData;
    if (selectedSearch !== "") {
      const lowercaseSearch = selectedSearch.toLowerCase();
      filtered = filtered.filter((c) =>
        c.title?.toLowerCase().includes(lowercaseSearch) ||
        c.description?.toLowerCase().includes(lowercaseSearch) ||
        c.issue_by?.toLowerCase().includes(lowercaseSearch)
      );
    }
    return filtered;
  };

  const filteredData = applyFilters();

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const hasActiveFilters = toggleCompany !== "null" || selectedSearch !== "";

  const clearAllFilters = () => {
    setToggleCompany("null");
    setSearch("");
  };

  const showActionColumn = role === "Admin";
  const columnCount = 8 + (showActionColumn ? 1 : 0);

  return (
    <>
      <div className="project-details-modern">

        <div className="progress-modern-container">


          {showFilters && (
            <div className="filter-bar-attractive">
              <div className="filter-group-attractive">

                <div className="filter-chip" style={{ minWidth: '260px' }}>
                  <div><Search size={15} /></div>
                  <div className="filter-chip-content" style={{ width: '100%' }}>
                    <input
                      className="modern-select"
                      style={{ width: '100%' }}
                      placeholder="Search Circular"
                      value={selectedSearch}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>

                {hasActiveFilters && (
                  <button className="clear-filters-btn" onClick={clearAllFilters}>
                    <X size={13} />
                    Clear
                  </button>
                )}
              </div>
            </div>
          )}


          <div style={{ display: 'flex', gap: '10px', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="stats-minimal-row">
              <div className="stat-minimal-item">
                <FileText size={14} />
                <span>Showing</span>
                <strong>{filteredData?.length || 0} circulars</strong>
              </div>
            </div>


            <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
              <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                <Filter size={14} />
                <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
              </button>
              {role !== "Checker" && role !== "ViewAccess" && (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <AddCircular
                    getSiteCirculars={getSiteCirculars}
                    sectorList={sectorData}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="table-wrapper-minimal table-box scroll-container-table">
            {buffer ? (
              <div className="loader-minimal">
                <div className="spinner-minimal"></div>
              </div>
            ) : (
              <table className="progress-table-minimal">
                <thead className="table-heading" style={{ zIndex: 1000 }}>
                  <tr>
                    <th className="col-sno" style={{ width: '5%' }}>#</th>
                    <th className="col-period text-center">Circular</th>
                    <th className="col-submitted text-center" style={{ width: '10%' }}>Publish Date</th>
                    <th className="col-submitted text-center" style={{ width: '12%' }}>Issue By</th>
                    <th className="col-approved text-center" style={{ width: '10%' }}>Attachment</th>
                    {showActionColumn && <th className="col-action text-center" style={{ width: '12%' }}>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {filteredData?.map((i, index) => {
                    const isExpanded = expandedRow === index;
                    return (
                      <React.Fragment key={index}>
                        <tr className="progress-row">
                          <td className="col-sno text-start">{index + 1}.</td>
                          <td className="col-period">
                            <div className="flex-row" style={{ justifyContent: 'center', alignItems: 'center' }}>
                              <button className="period-trigger" style={{ width: "70%", textAlign: 'left', justifyContent: 'center' }} onClick={() => toggleRow(index)}>
                                <FileText size={12} />
                                <span>{i.title}</span>
                                {isExpanded ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
                              </button>
                            </div>
                          </td>
                          <td className="col-submitted text-center">
                            {i.publish_date ? formattedDateLong(i.publish_date) : "-"}
                          </td>
                          <td className="col-submitted text-center">
                            <span className="badge-value">{i.issue_by ? i.issue_by : "-"}</span>
                          </td>
                          <td className="col-approved text-center">
                            {i.file ? (
                              <a href={i.file} target="_blank" rel="noreferrer">
                                <div className="flex-row justify-center">
                                  <DocumentfOLDIcon />
                                </div>
                              </a>
                            ) : (
                              <span className="empty-value">-</span>
                            )}
                          </td>
                          {showActionColumn && (
                            <td className="col-action">
                              <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                                <UpdateCicular i={i} getSiteCirculars={getSiteCirculars} />
                                <DeleteCircular i={i} getCircular={getSiteCirculars} />
                              </div>
                            </td>
                          )}
                        </tr>

                        {isExpanded && (
                          <tr className="expanded-row">
                            <td colSpan={columnCount}>
                              <div className="expanded-content-attractive">
                                <div className="expanded-content-header">
                                  <div className="expanded-content-title">
                                    <Sparkles size={13} />
                                    <span>Full Circular Details</span>
                                  </div>
                                </div>

                                <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                  <div className="stage-card submitted" style={{ flex: 1, minWidth: '240px' }}>
                                    <div className="stage-header">
                                      <FileText size={14} />
                                      <span>Circular Info</span>
                                    </div>
                                    <div className="stage-content">
                                      <div className="stage-row"><span className="stage-label">Circular Number</span><span className="amount">{i?.title || "-"}</span></div>
                                      <div className="stage-row"><span className="stage-label">Issue By</span><span className="amount">{i?.issue_by || "-"}</span></div>
                                      <div className="stage-row"><span className="stage-label">Publish Date</span><span className="amount">{i?.publish_date ? formattedDateLong(i.publish_date) : "-"}</span></div>
                                    </div>
                                  </div>

                                  {i?.related_to_department?.length > 0 && (
                                    <div className="stage-card recommended" style={{ flex: 1, minWidth: '240px' }}>
                                      <div className="stage-header">
                                        <Building2 size={14} />
                                        <span>Related Departments</span>
                                      </div>
                                      <div className="stage-content">
                                        <ul style={{ paddingLeft: '18px', margin: 0 }}>
                                          {i.related_to_department.map((dept, idx) => (
                                            <li key={idx} style={{ marginBottom: '6px', listStyleType: 'disc' }}>{toTitleCase(dept)}</li>
                                          ))}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {i?.description && (
                                  <div style={{ marginTop: '12px', padding: '10px 14px', background: '#f8fafc', borderRadius: '10px', fontSize: '12px', color: '#475569' }}>
                                    <strong style={{ color: '#1e293b' }}>Description: </strong>{i.description}
                                  </div>
                                )}

                                {i?.remarks && (
                                  <div style={{ marginTop: '10px', padding: '10px 14px', background: '#f8fafc', borderRadius: '10px', fontSize: '12px', color: '#475569' }}>
                                    <strong style={{ color: '#1e293b' }}>Remarks: </strong>{i.remarks}
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}

                  {(!filteredData || filteredData.length === 0) && (
                    <tr>
                      <td colSpan={columnCount}>
                        <div className="empty-state-attractive">
                          <div className="empty-state-icon-wrap">
                            <FileText size={32} />
                          </div>
                          <h4 className="empty-state-title">No Circulars Found</h4>
                          <p className="empty-state-subtitle">
                            Try adjusting your filters or search to find what you're looking for.
                          </p>

                          {hasActiveFilters && (
                            <button className="empty-state-clear-btn" onClick={clearAllFilters}>
                              <X size={13} />
                              Clear Filters
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
      </div>
    </>
  );
};




export default SiteManagement;
